import classnames from 'classnames'
import moment from 'moment'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import SwipeableViews from 'react-swipeable-views'

import { Build, IMAGE_SIZES, Shield, Trophy } from 'images'

import { playingNowFetch, playingNowFetchCanceled } from './PlayingNowActions'

class PlayingNow extends PureComponent {
  constructor(props) {
    super(props)
    this.state = { index: 0 }
  }

  componentDidMount() {
    this.props.playingNowFetch()
  }

  componentWillUnmount() {
    this.props.playingNowFetchCanceled()
  }

  onChangeIndex = (moveTo) => {
    const { matches } = this.props
    const pages = matches.length
    let index = moveTo

    if (index < 0) {
      index = 0
    } else if (index > pages - 1) {
      index = pages - 1
    }

    const match = matches[index]
    if (match) {
      this.setState({
        index,
      })
    }
  }

  render() {
    const { matches } = this.props
    const { index } = this.state

    if (!matches.length) {
      return null
    }

    const playing = matches.filter((match) => match.status === 'doing' || match.status === 'todo')

    return (
      <div className="PlayingNow rounded bg-white mb-2 p-2">
        <SwipeableViews
          className="border rounded"
          enableMouseEvents
          index={index}
          onChangeIndex={this.onChangeIndex}
          resistance
        >
          {playing.map((match) => (
            <div key={match.id} className="flex w-full gap-2 items-center justify-around p-1 text-sm max-w-144 mx-auto">
              <Link
                className="flex items-start justify-center !no-underline *:p-0.5 text-text whitespace-nowrap"
                to={`/sports/soccer/match/${match.id}`}
              >
                <span className="flex flex-col gap-1 items-center">
                  <Shield
                    className="border-current text-current"
                    size="4em"
                    src={match.local.avatar}
                    srcImageSize={IMAGE_SIZES.FIT_100_100}
                  />
                  <div className="w-[10ch] text-center text-sm">{match.local.nickname}</div>
                </span>
                <div
                  className={classnames(
                    'shrink flex flex-col items-center match self-center whitespace-nowrap font-bold',
                    match.status,
                  )}
                >
                  <div className="flex items-start justify-center gap-0.5 text-xl leading-4">
                    <div className="text-right">
                      {match.local_goals}
                      {(!!match.local_definition_goals || !!match.visitor_definition_goals) && (
                        <div className="text-sm leading-4">({match.local_definition_goals})</div>
                      )}
                    </div>
                    <div>~</div>
                    <div className="text-left">
                      {match.visitor_goals}
                      {(!!match.local_definition_goals || !!match.visitor_definition_goals) && (
                        <div className="text-sm leading-4">({match.visitor_definition_goals})</div>
                      )}
                    </div>
                  </div>
                  <div className="py-0.5">
                    {match.status === 'doing' ? `${match.minutes}'` : match.date.from(moment())}
                  </div>
                </div>
                <span className="flex flex-col gap-1 items-center">
                  <Shield
                    className="border-current text-current"
                    size="4em"
                    src={match.visitor.avatar}
                    srcImageSize={IMAGE_SIZES.FIT_100_100}
                  />
                  <div className="w-[10ch] text-center text-sm">{match.visitor.nickname}</div>
                </span>
              </Link>
              <div className="flex flex-col gap-1 items-center justify-center overflow-hidden">
                <Link
                  className="flex gap-1 items-center max-w-full"
                  to={`/institution/${match.stage.tournament.tournament.institution.id}`}
                >
                  <Build
                    className="border-current text-current"
                    size="1.5em"
                    src={match.stage.tournament.tournament.institution.avatar}
                    srcImageSize={IMAGE_SIZES.FIT_100_100}
                  />
                  <span className="truncate">{match.stage.tournament.tournament.institution.name}</span>
                </Link>
                <Link
                  className="flex gap-1 items-center max-w-full"
                  to={`/sports/tournament/${match.stage.tournament.tournament.id}`}
                >
                  <Trophy
                    className="border-current text-current"
                    size="1.5em"
                    src={match.stage.tournament.tournament.avatar}
                    srcImageSize={IMAGE_SIZES.FIT_100_100}
                  />
                  <span className="truncate">{match.stage.tournament.tournament.name}</span>
                </Link>
                <span className="truncate text-sm max-w-full">Fase {match.stage.name}</span>
              </div>
            </div>
          ))}
        </SwipeableViews>
        <div className="flex gap-2 items-center justify-center *:p-2 pt-1.5">
          {playing.map((match, pos) => (
            <button
              key={match.id}
              className={classnames(
                'match cursor-pointer bg-current rounded-full ring-green ring-offset-1 hover:ring-1',
                match.status,
                pos === index && 'ring-1',
              )}
              onClick={() => this.onChangeIndex(pos)}
              type="button"
            />
          ))}
        </div>
      </div>
    )
  }
}

PlayingNow.propTypes = {
  matches: PropTypes.array.isRequired,
  playingNowFetch: PropTypes.func.isRequired,
  playingNowFetchCanceled: PropTypes.func.isRequired,
}

export default connect(({ playingNow }) => ({ matches: playingNow.data || [] }), {
  playingNowFetch,
  playingNowFetchCanceled,
})(PlayingNow)
